/* LiebesBoxi – Warenkorbseite: Mengen ändern und Grußkarten-Text automatisch speichern.
   Ersetzt die Theme-Komponenten (cart-items, quantity-input, cart-note), die im Layout nicht geladen werden. */
(function () {
  var root = document.querySelector('cart-items');
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function post(path, body) {
    return fetch(base + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw r;
      return r.json();
    });
  }

  if (root) {
    var busy = false;
    function setQty(input, qty) {
      if (busy) return;
      busy = true;
      root.classList.add('lbc-busy');
      post('cart/change.js', { line: parseInt(input.dataset.index, 10), quantity: qty })
        .then(function () { window.location.reload(); })
        .catch(function () {
          busy = false;
          root.classList.remove('lbc-busy');
          var err = document.getElementById('Line-item-error-' + input.dataset.index);
          if (err) err.querySelector('.cart-item__error-text').textContent = 'Die Menge konnte nicht geändert werden. Bitte versuch es noch einmal.';
        });
    }

    root.querySelectorAll('quantity-input').forEach(function (qi) {
      var input = qi.querySelector('.quantity__input');
      if (!input) return;
      qi.querySelectorAll('.quantity__button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(input.step, 10) || 1;
          var val = parseInt(input.value, 10) || 0;
          var next = btn.name === 'plus' ? val + step : Math.max(val - step, 0);
          setQty(input, next);
        });
      });
      input.addEventListener('change', function () {
        var v = parseInt(input.value, 10);
        if (!isNaN(v) && v >= 0) setQty(input, v);
      });
    });
  }

  var note = document.getElementById('Cart-note');
  if (note) {
    var count = document.getElementById('lbc-note-count');
    var status = document.getElementById('lbc-note-status');
    var timer;
    function save() {
      post('cart/update.js', { note: note.value })
        .then(function () { if (status) status.textContent = 'Gespeichert'; })
        .catch(function () { if (status) status.textContent = 'Nicht gespeichert – bitte noch einmal tippen.'; });
    }
    note.addEventListener('input', function () {
      if (count) count.textContent = note.value.length + '/' + note.maxLength;
      if (status) status.textContent = '';
      clearTimeout(timer);
      timer = setTimeout(save, 700);
    });
    note.addEventListener('blur', function () { clearTimeout(timer); save(); });
  }
})();
